import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getEmployee = ({
  churchId,
  isDenomination,
  denominationId,
  employeeId
}) => {
  return axios.get(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/employees/${employeeId}`
  );
};

export const useEmployee = ({
  churchId,
  isDenomination,
  denominationId,
  employeeId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["employee", employeeId],
    queryFn: () =>
      getEmployee({ churchId, isDenomination, denominationId, employeeId })
  });
};
